import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectBlockState } from './block.selectors';
import { selectSystemState } from './system.selectors';

export const selectSystemTotalizerComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.SystemTotalizerComponent
);

export const selectSystemEnergyStateBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectSystemTotalizerComponent,
  (systemState, systemTotalizerComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = systemTotalizerComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.systemEnergyState;
  }
);

export const selectSystemEnergyStateBySystemUidAndDefaultInstance = (systemUid: string) => createSelector(
  selectSystemTotalizerComponent,
  (systemTotalizerComponent) => {
    return Object.values(systemTotalizerComponent).find((block) => block[systemUid])?.[systemUid]?.systemEnergyState;
  }
);

export const selectSystemTotalizerStateBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectSystemTotalizerComponent,
  (systemState, systemTotalizerComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = systemTotalizerComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.state;
  }
);
